












import Vue from 'vue';
import { Type, EntityType } from 'expangine-runtime';
import { Registry } from '../runtime/Registry';
import { CopyModifier } from '../runtime/hooks/ClipboardHooks';
import { getEditEntity } from './EditEntity';


export default Vue.extend({
  props: {
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    type: {
      type: Object as () => Type | null,
      default: null,
    },
  },
  computed: {
    code(): string {
      return this.type
        ? this.registry.getTypeDescribeLong(this.type, '&nbsp;&nbsp;', '<br>')
        : '';
    },
    canView(): boolean {
      return this.type instanceof EntityType;
    },
  },
  methods: {
    async copy() {
      const { type, registry } = this;

      if (type) {
        const typeSettings = registry.getTypeSettings(type);
        const option = CopyModifier.getOption({
          type, 
          registry,
          typeSettings,
        });

        if (option) {
          await option.value();
        }
      }      
    },
    async view() {
      const { type, registry } = this;

      if (type instanceof EntityType) {
        await getEditEntity({
          name: type.options,
          registry,
        });
      }
    },
  },
});
